import React from "react";
import { SectionCard } from "../../../components/ui";

export default function EventPlanningPanel({ defenseSummary, autoPopulateControls, children }) {
  return (
    <SectionCard className="events-panel-shell events-panel-planning" sx={{ p: 1.75 }}>
      <div className="events-panel-header">
        <h4>Planning Workspace</h4>
        <span>{defenseSummary}</span>
      </div>
      {autoPopulateControls}
      <div className="events-panel-content">{children}</div>
    </SectionCard>
  );
}
